import { Device } from '@capacitor/device';
import { SpeechRecognition } from "@capacitor-community/speech-recognition";
import { Subject } from 'rxjs';

declare var window: any;

export class MarvSpeechToText {
    
    codeLanguage: string;
    text: string = '';
    startRecord: boolean = false;
    audioStartRecord: boolean = false;
    onStartRecord: Subject<boolean> = new Subject();
    onStopRecord: Subject<string> = new Subject();
    onError: Subject<string> = new Subject();
    
    static async IsAvailable(): Promise<boolean> {
        return false;
    }
    
    startSpeechRecognition(){};
    stopSpeechRecognition(){};
    abortSpeechRecognition(){};
    destroySpeechRecognition(){};
    
    static async GetInstance(codeLanguage: string): Promise<MarvSpeechToText> {
        const info = await Device.getInfo();    
        if(info.platform === 'web'){ 
            return await MarvSpeechToTextDesktop.GetInstance(codeLanguage);
        }
        else{
            return await MarvSpeechToTextDesktop.GetInstance(codeLanguage);
        }
    }
    
}

export class MarvSpeechToTextMobile extends MarvSpeechToText {  

    timeoutStartRecord: any = null;
    timeoutStopRecord: any = null;

    static override async GetInstance(codeLanguage: string): Promise<MarvSpeechToTextMobile> {
          let c = new MarvSpeechToTextMobile();
          c.codeLanguage = codeLanguage;
          await c.init();
          return c;
    }
  
    static override async IsAvailable(): Promise<boolean> {
        return false;
        return (await SpeechRecognition.available()).available;
    }
    
    async init() {
        await SpeechRecognition.addListener('partialResults', (data) => {  
            if(this.startRecord){
                this.audioStartRecord = true;
                this.onStartRecord.next(true);

                if(this.timeoutStartRecord){
                    clearTimeout(this.timeoutStartRecord);
                }
                this.timeoutStartRecord = setTimeout(() => {
                    this.audioStartRecord = false;       
                    this.onStartRecord.next(false);             
                }, 100); 

                if(this.timeoutStopRecord){
                    clearTimeout(this.timeoutStopRecord);
                }
                this.timeoutStopRecord = setTimeout(() => {
                    let text = (data.matches.length > 0 && data.matches[0].length > 0 ? data.matches[0] : '');
                    this.onStopRecord.next(text);
                    this.stopSpeechRecognition();
                }, 2000);  
            }               
        });
    }
    
    override startSpeechRecognition() {
        this.abortSpeechRecognition();
        this.text = '';
        setTimeout(async () => {            
            let permissionStatus = await SpeechRecognition.requestPermissions();
            if(permissionStatus.speechRecognition === 'granted'){
                
                SpeechRecognition.start({
                    language: this.codeLanguage,
                    partialResults: true
                });
                this.startRecord = true;
                this.timeoutStopRecord = setTimeout(() => {
                    this.stopSpeechRecognition();
                }, 2000);   
            }   
            else{
                this.onError.next('MSG_ERROR_MICRO_NOT_ALLOWED');
            }
        }, 250);
    }
    
    override stopSpeechRecognition() {
        SpeechRecognition.stop();
        this.audioStartRecord = false;                
        this.startRecord = false;  
    }
    
    override abortSpeechRecognition() {
        SpeechRecognition.stop();
        this.text = '';
        this.startRecord = false;
        this.audioStartRecord = false;
        if(this.timeoutStartRecord){
            clearTimeout(this.timeoutStartRecord);
        }
        this.timeoutStartRecord = null;
        if(this.timeoutStopRecord){
            clearTimeout(this.timeoutStopRecord);
        }
        this.timeoutStopRecord = null;
    }
    
    override destroySpeechRecognition() {
        this.abortSpeechRecognition();
        SpeechRecognition.removeAllListeners();
    }
}

export class MarvSpeechToTextDesktop extends MarvSpeechToText {
    
    speechRecognition: any = null;
    timeoutStartRecord: any = null;

    static override async GetInstance(codeLanguage: string): Promise<MarvSpeechToTextDesktop> {
        let c = new MarvSpeechToTextDesktop();
        c.codeLanguage = codeLanguage;
        c.init();
        return c;
    }
    
    static override async IsAvailable(): Promise<boolean> {
        return false;
        let SpeechRecognitionClass = MarvSpeechToTextDesktop.GetSpeechRecognitionClass();
        return (SpeechRecognitionClass !== null);
    }

    static GetSpeechRecognitionClass(): any {
        return window.SpeechRecognition
            || window.webkitSpeechRecognition
            || window.mozSpeechRecognition
            || window.msSpeechRecognition
            || null;
    }

    init() {
        let SpeechRecognitionClass = MarvSpeechToTextDesktop.GetSpeechRecognitionClass();
        if(SpeechRecognitionClass){
            this.speechRecognition = new (SpeechRecognitionClass);

            this.speechRecognition.lang = this.codeLanguage;

            this.speechRecognition.onaudiostart = () => {
                this.startRecord = true;
                this.onStartRecord.next(true);
            }
    
            this.speechRecognition.onsoundstart = () => {             
                this.audioStartRecord = true;
                this.onStartRecord.next(true);
            }

            this.speechRecognition.onsoundend = () => {            
                this.audioStartRecord = false;
                this.onStartRecord.next(false);
            }
            
            this.speechRecognition.onresult = (event: any) => {      
                if(event.results 
                    && event.results[0] 
                    && event.results[0][0] 
                    && event.results[0][0].transcript){
                    this.text = event.results[0][0].transcript;
                }
            };
            
            this.speechRecognition.onend = () => {                        
                this.startRecord = false;
                this.onStopRecord.next(this.text);
            }
            
            this.speechRecognition.onerror = (event: any) => {            
                let errorMessage = 'MSG_ERROR_MICRO_DEFAULT';
                switch(event.error){
                    case 'not-allowed' :
                        errorMessage = 'MSG_ERROR_MICRO_NOT_ALLOWED';
                        break;
                    case 'no-speech' :
                        errorMessage = 'MSG_ERROR_NO_SPEECH';
                        break;
                }
                this.onError.next(errorMessage);
            }

        }
    }
    
    override startSpeechRecognition() {
        this.abortSpeechRecognition();        
        if(this.speechRecognition){
            this.timeoutStartRecord = setTimeout(() => {                
                this.speechRecognition.start();
            }, 250);
        }
    }
    
    override stopSpeechRecognition() {
        if(this.speechRecognition){
            this.speechRecognition.abort();
        }
        this.audioStartRecord = false;                
        this.startRecord = false;  
    }
    
    override abortSpeechRecognition() {
        if(this.speechRecognition){
            this.speechRecognition.abort();
        }
        this.text = '';
        this.startRecord = false;
        this.audioStartRecord = false;
        if(this.timeoutStartRecord){
            clearTimeout(this.timeoutStartRecord);
        }
        this.timeoutStartRecord = null;        
    }
    
    override destroySpeechRecognition() {
        this.abortSpeechRecognition();
    }
}